<template>
    <div class="main">
        <c-panel :title="titulo" titleIcon="fas fa-graduation-cap">
            <aprendizado></aprendizado>
        </c-panel>
    </div>
</template>
<script>
import aprendizado from "./aprendizado"
export default {
    components: { aprendizado },
    data () { return { titulo: '' } },
    created () { this.titulo = (this.$route.meta && this.$route.meta.title) || 'Aprendizado do Assistente' }
}
</script>
